const Vue = require('vue');

/**
 * ValidatePostCode
 * @class
 */
class ValidatePostCode {

  /**
   * @instance
   * @private
   */
  get ERROR_TEXT() {
    return {
      HalfNum: '半角数字で入力してください',
    }
  }

  /**
   * @instance
   * @param el {string|HTMLElement} element
   */
  constructor(el) {

    this.vm = new Vue({
      el: el,
      data: {
        val: {
          postCode: [ '', '' ],
        },
        validate: {
          postCode: [ false, false ],
        },
        err: {
          postCode: [ null, null ],
        },
        isCorrect: false,
      },
      components: {
        'efo': {
          props: ['err'],
          template: '#efo-tmp',
        },
      },
      methods: {
        validatePostCode: (i) => {
          setTimeout(() => {
            this.vdPostCode(i, this.vm.val.postCode[i]);
          }, 100);
        },
        submit: (e) => {
          e.preventDefault();
          this.vdAll();
          setTimeout(() => {
            if(this.vm.isCorrect) {
              e.target.submit();
            }
          }, 0);
        },
      },
    });

    this.vm.$watch('validate', () => {
      this.setIsCorrect();
    }, { deep: true });

    this.setIsCorrect();
  }

  // /**
  //  * @instance
  //  * @private
  //  */
  // vdAll() {
  //   _.forEach(this.vm.val.postCode, (val, i) => {
  //     this.vdPostCode(i, val);
  //   });
  // }

  /**
   * @instance
   * @private
   * @param val {string}
   */
  vdPostCode(i, val) {
    if(val !== '') {
      let _val = this.toNumHalf(val);
      this.vm.val.postCode.$set(i, _val);
      if(!this.validateHalfNum(_val)) {
        this.vm.err.postCode.$set(i, this.ERROR_TEXT.HalfNum);
        this.vm.validate.postCode.$set(i, false);
        return;
      }
    }
    this.vm.err.postCode.$set(i, null);
    this.vm.validate.postCode.$set(i, true);
  }

  /**
   * @instance
   * @private
   * @param val {string}
   */
  validateHalfNum(val) {
    return val.match(/^[0-9]+$/) ? true : false;
  }

  /**
   * @instance
   * @private
   * @param str {string}
   */
  toNumHalf(str) {
    return str.replace(/[０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
  }

  /**
   * @instance
   * @private
   */
  setIsCorrect() {
    const vd = this.vm.validate;

    if(vd.yen) {
      this.vm.isCorrect = true;
    } else {
      this.vm.isCorrect = false;
    }
  }

}

/**
 * class exports
 */
module.exports = ValidatePostCode;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/form/validate-post-code.js
 **/